import { Language } from '../models/Translation';
import { useAppSelector } from '../state/store';

const en = {
  en: '🇬🇧 English',
  es: '🇪🇸 Spanish',
  movies: 'Movies',
  search: 'Search',
  shows: 'Shows',
  calendar: 'Calendar',
  profile: 'Profile',
  to_show: 'Show {}',
  link_copied: 'Link to "{}" copied',
  mark_not_watched: 'Mark all as not watched',
  mark_watched: 'Mark all as watched',
  none_found: 'None',
  action: 'action',
  adventure: 'adventure',
  animation: 'animation',
  anime: 'anime',
  comedy: 'comedy',
  crime: 'crime',
  documentary: 'documentary',
  drama: 'drama',
  family: 'family',
  fantasy: 'fantasy',
  history: 'history',
  holiday: 'holiday',
  horror: 'horror',
  music: 'music',
  musical: 'musical',
  mystery: 'mystery',
  none: 'none',
  romance: 'romance',
  science: 'sci-fi',
  short: 'short',
  sporting: 'sporting',
  superhero: 'superhero',
  suspense: 'suspense',
  thriller: 'thriller',
  war: 'war',
  western: 'western',
  'genre_28': 'Action',
  'genre_12': 'Adventure',
  'genre_16': 'Animation',
  'genre_35': 'Comedy',
  'genre_80': 'Crime',
  'genre_99': 'Documentary',
  'genre_18': 'Drama',
  'genre_10751': 'Family',
  'genre_14': 'Fantasy',
  'genre_36': 'History',
  'genre_27': 'Horror',
  'genre_10402': 'Music',
  'genre_9648': 'Mystery',
  'genre_10749': 'Romance',
  'genre_878': 'Science Fiction',
  'genre_53': 'Thriller',
  'genre_10770': 'TV Movie',
  'genre_10752': 'War',
  'genre_37': 'Western',
  'genre_10759': 'Action & Adventure',
  'genre_10762': 'Kids',
  'genre_10763': 'News',
  'genre_10764': 'Reality',
  'genre_10765': 'Sci-Fi & Fantasy',
  'genre_10766': 'Soap',
  'genre_10767': 'Talk',
  'genre_10768': 'War & Politics',
  loading: 'Loading',
  new_version: 'New version available ,',
  update: 'Update',
  popular_show: 'Popular shows',
  popular_movie: 'Popular movies',
  add_watchlist: 'Add to watchlist',
  added_watchlist: 'Remove from watchlist',
  watched: 'Watched',
  watcheds: 'Watcheds',
  watchlist: 'Watchlist',
  watchlists: 'Watchlists',
  season: 'Season',
  specials: 'Specials',
  no_movies: 'There are no movies',
  no_shows: 'There are no shows',
  people: 'People',
  no_people: 'There are no people',
  search_placeholder: '🔍 Search for a movie, show or personn',
  all: 'All',
  my_collection: 'My collection',
  show_watcheds: 'Following',
  bio: 'Biography',
  episodes: 'Episodes',
  have_watched: 'Watched',
  have_watched_f: 'Watched',
  dark: 'Dark',
  light: 'Light',
  system: 'System',
  direction: 'Director',
  cast: 'Cast',
  'returning series': 'returning series',
  'in production': 'in production',
  planned: 'planned',
  canceled: 'canceled',
  ended: 'ended',
  'login-perks': 'To save it on you personal list!',
  overview: 'Overview',
  related: 'Related',
  genres: 'Genres',
  'empty-login-perk': 'Start following a show or add a movie to your watchlist',
  'call-to-action': 'Go for it!',
  'days-aprox': '{} days, {} hours, {} minutes aprox',
  'hours-aprox': '{} hours, {} minutes aprox',
  'loading-session': 'Loading user session...',
  'login-magic-link': 'Send a magic link ✨',
  refresh: 'Refresh',
  'nothing-yet': 'Nothing to see here yet',
  'extra-scenes': 'Extra scenes',
  'during-credits': 'During credits',
  'post-credits': 'Post credits',
  'login-code': 'Login with code',
  'already-have-code': 'I already have the code',
  'code-sent':
    'Code sent to your email, click in the link from the email or paste the code below to log in!',
  'no-episodes': 'No episodes available yet',
  studios: 'Studios',
  in_spain: 'In Spain',
  'no-info-title': 'Ups, there was a problem',
  show: 'show',
  movie: 'movie',
  'no-info-message':
    'It looks like this {} has no information available yet, try again later.',
  'go-back': 'Go back',
  retry: 'Retry',
  avg: 'AVG',
  episode_num: 'Episode {}',
  votes: 'votes',
  season_abbreviation: 'S',
  episode_abbreviation: 'E',
  next_to_watch: 'Next',
  all_watched: 'All watched',
  hide_finished: 'Hide shows with no new episodes',
};

const es = {
  en: '🇬🇧 Inglés',
  es: '🇪🇸 Español',
  movies: 'Películas',
  search: 'Buscar',
  shows: 'Series',
  calendar: 'Calendario',
  profile: 'Perfil',
  to_show: 'Mostrar {}',
  link_copied: 'Enlace a "{}" copiado',
  mark_not_watched: 'Marcar todo como no vistos',
  mark_watched: 'Marcar todo como vistos',
  none_found: 'Ninguno',
  action: 'acción',
  adventure: 'aventura',
  animation: 'animación',
  anime: 'anime',
  comedy: 'comedia',
  crime: 'crimen',
  documentary: 'documental',
  drama: 'drama',
  family: 'familiar',
  fantasy: 'fanstasía',
  history: 'histórica',
  holiday: 'vacaciones',
  horror: 'terror',
  music: 'música',
  musical: 'musical',
  mystery: 'misterio',
  none: 'ninguna',
  romance: 'romántica',
  science: 'ciencia-ficción',
  short: 'corto',
  sporting: 'deportes',
  superhero: 'superhéroes',
  suspense: 'suspense',
  thriller: 'thriller',
  war: 'bélica',
  western: 'western',
  'genre_28': 'Acción',
  'genre_12': 'Aventura',
  'genre_16': 'Animación',
  'genre_35': 'Comedia',
  'genre_80': 'Crimen',
  'genre_99': 'Documental',
  'genre_18': 'Drama',
  'genre_10751': 'Familia',
  'genre_14': 'Fantasía',
  'genre_36': 'Historia',
  'genre_27': 'Terror',
  'genre_10402': 'Música',
  'genre_9648': 'Misterio',
  'genre_10749': 'Romance',
  'genre_878': 'Ciencia ficción',
  'genre_53': 'Suspense',
  'genre_10770': 'Película de TV',
  'genre_10752': 'Bélica',
  'genre_37': 'Western',
  'genre_10759': 'Acción y aventura',
  'genre_10762': 'Infantil',
  'genre_10763': 'Noticias',
  'genre_10764': 'Reality',
  'genre_10765': 'Ciencia ficción y fantasía',
  'genre_10766': 'Soap opera',
  'genre_10767': 'Talk show',
  'genre_10768': 'Bélica y política',
  loading: 'Cargando',
  new_version: 'Nueva versión disponible ,',
  update: 'Actualizar',
  popular_show: 'Series populares',
  popular_movie: 'Películas populares',
  add_watchlist: 'Añadir a pendientes',
  added_watchlist: 'Eliminar de pendientes',
  watched: 'Vista',
  watcheds: 'Vistas',
  watchlist: 'Pendiente',
  watchlists: 'Pendientes',
  season: 'Temporada',
  specials: 'Especiales',
  no_movies: 'No hay películas',
  no_shows: 'No hay series',
  people: 'Personas',
  no_people: 'No hay personas',
  search_placeholder: '🔍 Busca una película, serie o persona',
  all: 'Todo',
  my_collection: 'Mi colección',
  show_watcheds: 'Siguiendo',
  bio: 'Biografía',
  episodes: 'Episodios',
  have_watched: 'Vistos',
  have_watched_f: 'Vistas',
  dark: 'Oscuro',
  light: 'Claro',
  system: 'Sistema',
  direction: 'Dirección',
  cast: 'Reparto',
  'returning series': 'en antena',
  'in production': 'en producción',
  planned: 'planeada',
  canceled: 'cancelada',
  ended: 'terminada',
  'login-perks': 'Para guardarla en tu lista personal!',
  overview: 'Sinopsis',
  related: 'Relacionados',
  genres: 'Géneros',
  'empty-login-perk':
    'Empieza a seguir una serie o añade tu una película a tu lista',
  'call-to-action': 'Vamos!',
  'days-aprox': '{} días, {} horas, {} minutos aprox',
  'hours-aprox': '{} horas, {} minutos aprox',
  'loading-session': 'Cargando sesión de usuario...',
  'login-magic-link': 'Enviar un enlace mágico ✨',
  refresh: 'Recargar',
  'nothing-yet': 'Nada por aquí todavía',
  'extra-scenes': 'Escenas extra',
  'during-credits': 'Durante créditos',
  'post-credits': 'Post-créditos',
  'login-code': 'Entrar con código',
  'already-have-code': 'Ya tengo el código',
  'code-sent':
    'Código enviado al correo. Pulsa en el enlace recibido o introduce el código debajo!',
  'no-episodes': 'Aún no hay episodios disponibles',
  studios: 'Estudios',
  in_spain: 'En España',
  'no-info-title': 'Ups, ha habido un problema',
  show: 'serie',
  movie: 'película',
  'no-info-message':
    'Parece que esta {} no tiene información disponible, inténtalo más tarde.',
  'no-info-movie-message':
    'Parece que esta película no tiene información disponible, inténtalo más tarde.',
  'go-back': 'Volver',
  retry: 'Reintentar',
  avg: 'AVG',
  episode_num: 'Episodio {}',
  votes: 'votos',
  season_abbreviation: 'T',
  episode_abbreviation: 'E',
  next_to_watch: 'Siguiente',
  all_watched: 'Todo visto',
  hide_finished: 'Ocultar series sin episodios nuevos',
};

const translations: Record<Language, Record<string, string>> = {
  en,
  es,
};

export const useTranslate = () => {
  const language = useAppSelector((state) => state.config.language);

  const t = (text: string, ...interpolations: (string | number)[]) => {
    let translation = translations[language][text] ?? text;
    let index = 0;
    while (translation.includes('{}')) {
      translation = translation.replace('{}', `${interpolations.at(index)}`);
      index++;
    }
    return translation;
  };

  return { t, language };
};
